// Theme configurations — aligned with Toyo.Games light design tokens
import { ThemeConfig } from './types';

const baseLightTheme: Omit<
  ThemeConfig,
  | 'name'
  | 'primaryColor'
  | 'primaryColorRgb'
  | 'secondaryColor'
  | 'secondaryColorRgb'
  | 'tertiaryColor'
  | 'tertiaryColorRgb'
  | 'highlightColor'
  | 'highlightColorRgb'
> = {
  accentColor: '#6a35c2',
  successColor: '#4caf50',
  warningColor: '#fbbf24',
  errorColor: '#ef4444',
  bgPrimary: '#ffffff',
  bgSecondary: '#f5f6f8',
  bgTertiary: '#eaecef',
  textPrimary: '#1a1a2e',
  textSecondary: '#5c6370',
  textMuted: 'rgba(92, 99, 112, 0.75)',
  borderLight: 'rgba(26, 26, 46, 0.06)',
  borderMedium: 'rgba(26, 26, 46, 0.12)',
};

export const blitzTheme: ThemeConfig = {
  ...baseLightTheme,
  name: 'blitz',
  primaryColor: '#ef4444',
  primaryColorRgb: '239, 68, 68',
  secondaryColor: '#e66b00',
  secondaryColorRgb: '230, 107, 0',
  tertiaryColor: '#F59E0B',
  tertiaryColorRgb: '245, 158, 11',
  highlightColor: '#FFE566',
  highlightColorRgb: '255, 229, 102',
};

export const coopTheme: ThemeConfig = {
  ...baseLightTheme,
  name: 'coop',
  primaryColor: '#f97316',
  primaryColorRgb: '249, 115, 22',
  secondaryColor: '#52ff00',
  secondaryColorRgb: '82, 255, 0',
  tertiaryColor: '#EA580C',
  tertiaryColorRgb: '234, 88, 12',
  highlightColor: '#52ff00',
  highlightColorRgb: '82, 255, 0',
};

export const partyTheme: ThemeConfig = {
  ...baseLightTheme,
  name: 'party',
  primaryColor: '#6a35c2',
  primaryColorRgb: '106, 53, 194',
  secondaryColor: '#e66b00',
  secondaryColorRgb: '230, 107, 0',
  tertiaryColor: '#F59E0B',
  tertiaryColorRgb: '245, 158, 11',
  highlightColor: '#FFEE58',
  highlightColorRgb: '255, 238, 88',
};

export const teamTheme: ThemeConfig = {
  ...baseLightTheme,
  name: 'team',
  primaryColor: '#1d63d1',
  primaryColorRgb: '29, 99, 209',
  secondaryColor: '#0d9488',
  secondaryColorRgb: '13, 148, 136',
  tertiaryColor: '#F59E0B',
  tertiaryColorRgb: '245, 158, 11',
  highlightColor: '#5EEAD4',
  highlightColorRgb: '94, 234, 212',
};

export const familyTheme: ThemeConfig = {
  ...baseLightTheme,
  name: 'family',
  primaryColor: '#4caf50',
  primaryColorRgb: '76, 175, 80',
  secondaryColor: '#EEFF00',
  secondaryColorRgb: '238, 255, 0',
  tertiaryColor: '#F59E0B',
  tertiaryColorRgb: '245, 158, 11',
  highlightColor: '#EEFF00',
  highlightColorRgb: '238, 255, 0',
};
